import { CarApiResponse } from './types'
import externalApiService from './../external-api'

export async function getModelsForMake(brand: string): Promise<string[]> {
  const url = `https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMake/${brand}?format=json`
  const mapper = (data: CarApiResponse): string[] => {
    return data.Results.map(item => item.Model_Name)
  }

  return externalApiService.fetchAndMap<CarApiResponse, string[]>(url, mapper)
}
